<template>
    <div class="container-fluid">
        <CRow class="pr-2">
    <CCol col="12" xl="12" class="p-0">
      <CCard>
        <CCardBody>

   <a-card class="edit-card" style="margin:0;" :body-style="{padding:0}">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Nastavenia > <router-link to="/managetranslations">Preklady</router-link></h6>
                            Preklady</span>
                            <span slot="extra">
         <a-select
             v-model="targetLang"
             size="small"
             style="width:170px"
             class="mr-2"
             placeholder="Cieľový jazyk"
             :disabled="bulkTranslating"
             :options="langs"
         />
         <a-popconfirm
             placement="bottomRight"
             okText="Áno, preložiť"
             cancelText="Zrušiť"
             :disabled="!targetLang || bulkTranslating"
             @confirm="translateAllToTarget"
         >
             <template slot="title">
                 Preložiť chýbajúce termíny ({{ missingForTargetCount }}) do jazyka <strong>{{ targetLangLabel }}</strong> cez AI?<br>
                 Už preložené termíny sa preskočia. Preklady prebehnú postupne.
             </template>
             <a-button type="primary" class="mr-2" :loading="bulkTranslating" :disabled="!targetLang || missingForTargetCount === 0">
                 <i class="fas fa-language mr-1"></i>Kompletný preklad<span v-if="targetLang && missingForTargetCount"> ({{ missingForTargetCount }})</span>
             </a-button>
         </a-popconfirm>
         <a-popconfirm
             v-if="untranslatedCount > 0"
             placement="bottomRight"
             okText="Áno, preložiť"
             cancelText="Zrušiť"
             @confirm="translateAllMissing"
         >
             <template slot="title">
                 Doplniť {{ untranslatedCount }} chýbajúcich prekladov cez AI? Preklady prebehnú postupne.
             </template>
             <a-button class="mr-2" :loading="bulkTranslating"><i class="fas fa-language mr-1"></i>Doplniť chýbajúce<span v-if="untranslatedCount"> ({{ untranslatedCount }})</span></a-button>
         </a-popconfirm>
         <a-button
             type="primary"
             class="mr-2"
             :loading="saving"
             :disabled="dirtyCount === 0"
             @click="saveAll"
         ><i class="fas fa-save mr-1"></i>Uložiť<span v-if="dirtyCount"> ({{ dirtyCount }})</span></a-button>
         <a-button @click="openAdd">Pridať termín</a-button>
                           </span>
                        <div class="table-responsive" :key="componentKey" v-if="translations">

                            <div class="skipass-prices ant-table-body">
                                <table style="width:100%" >
                                    <thead class="ant-table-thead" >
                                    <tr>
                                        <th>jazyk originál</th><th >originál</th> <th>jazyk preklad</th><th >preklad</th><th></th>
                                    </tr>
                                    </thead>
                                    <tbody class="ant-table-tbody">
                                    <tr  :key="date + 'ski'" v-for="(datas,date) in translations" :class="{ 'row-dirty': datas._dirty }">
                                        <td style="max-width:40px">{{datas.lang}}</td>
                                        <td style="font-size:12px;max-width:200px">{{datas.text}}</td>
                                        <td style="max-width:40px">{{datas.translang}}</td>
                                        <td style="font-size:12px;max-width:200px">
                                            <span v-if="datas.translation">{{datas.translation}}</span>
                                            <span v-else class="text-muted"><i>chýba</i></span>
                                            <a-tag v-if="datas._dirty" color="orange" class="ml-2">neuložené</a-tag>
                                        </td>
                                        <td class="text-right" style="white-space:nowrap">
                                            <a-button class="mr-2" size="small" :loading="rowTranslating === date" :disabled="!datas.text || !datas.translang" @click="translateRow(datas, date)"><i class="fas fa-language mr-1"></i>Preložiť</a-button>
                                            <a-button size="small" @click="openNew(datas)"><span class="btn-inner--icon" style="margin-right:5px"><i class="fas fa-pencil-alt"></i></span>Upraviť</a-button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
   </a-card>
        </CCardBody>
      </CCard>
    </CCol>
        </CRow>
        <a-modal title="Pridať termín" centered v-model="addTerm" @ok="handleOk" okText="Uložiť" cancelText="Zrušiť">
            <div class="additional-setup">
                <a-form-item
                        :label-col="formItemLayout.labelCol"
                        :wrapper-col="formItemLayout.wrapperCol"
                        label="Originálny jazyk"
                >  <a-select v-model="translation.lang" class="w-100" :options="langs"/>
                </a-form-item>
                <a-form-item
                        :label-col="formItemLayout.labelCol"
                        :wrapper-col="formItemLayout.wrapperCol"
                        label="Preklad do jazyka"
                >  <a-select defaultValue="1"  v-model="translation.translang" class="w-100" :options="langs"/>
                </a-form-item>
                <a-form-item
                        :label-col="formItemLayout.labelCol"
                        :wrapper-col="formItemLayout.wrapperCol"
                        label="Originál"
                > <a-input type="text" v-model="translation.text"></a-input>
                </a-form-item>
                <a-form-item
                        :label-col="formItemLayout.labelCol"
                        :wrapper-col="formItemLayout.wrapperCol"
                        label="Preklad"
                >  <a-input type="text" v-model="translation.translation"></a-input>
                </a-form-item>
                <a-form-item
                        :label-col="formItemLayout.labelCol"
                        :wrapper-col="formItemLayout.wrapperCol"
                        label=" "
                        :colon="false"
                >
                    <a-button
                        :loading="aiTranslating"
                        :disabled="!translation.text || !translation.translang"
                        @click="translateCurrent"
                    ><i class="fas fa-language mr-1"></i>Preložiť cez AI</a-button>
                </a-form-item>


            </div>
        </a-modal>



    </div>
</template>
<script>

    const formItemLayout = {
        labelCol: { span: 10 },
        wrapperCol: { span: 12 },
    };
    const formTailLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 8, offset: 4 },
    };

    import {dataService} from "../_services";
    import {Popconfirm} from "ant-design-vue"

    import Vue from "vue"
    import FormItem from 'ant-design-vue'

    import moment from 'moment'
    import 'moment/locale/sk';

    Vue.use(FormItem);

    var locale = {
        "lang": {
            "placeholder": "Vybrať dátum",
            "rangePlaceholder": ["Termín od", "do"],
            "today": "Dnes",
            "now": "Teraz",
            "backToToday": "Späť na dnes",
            "ok": "Ok",
            "clear": "Vymazať",
            "month": "Mesiac",
            "year": "Rok",
            "timeSelect": "Vybrať čas",
            "dateSelect": "Vybrať dátum",
            "monthSelect": "Vybrať mesiac",
            "yearSelect": "Vybrať rok",
            "decadeSelect": "Vybrať dekádu",
            "yearFormat": "YYYY",
            "dateFormat": "M/D/YYYY",
            "dayFormat": "D",
            "dateTimeFormat": "M/D/YYYY HH:mm:ss",
            "monthFormat": "MMMM",
            "monthBeforeYear": true,
            "previousMonth": "Predchádzajúci mesiac (PageUp)",
            "nextMonth": "Nasledujúci mesiac (PageDown)",
            "previousYear": "Minulý rok (Control + left)",
            "nextYear": "Nasledujúci rok (Control + right)",
            "previousDecade": "Minulá dekáda",
            "nextDecade": "Nasledujúca dekáda",
            "previousCentury": "Minulé storočie",
            "nextCentury": "Nasledujúce storoťie"
        },
        "timePickerLocale": {
            "placeholder": "Vybrať čas"
        },
        "dateFormat": "DD.MM.YYYY",
        "dateTimeFormat": "DD.MM.YYYY HH:mm:ss",
        "weekFormat": "YYYY-wo",
        "monthFormat": "YYYY-MM"
    }

    export default {
        name: "skipass",
        props: ["id"],
        components: {
            "a-popconfirm": Popconfirm
        },
        data() {
            return {
                data: [],
                ctt: [],
                langs:[],
                colorsto: JSON.parse(localStorage.colors),
                loading: false,
                filteredInfo: null,
                componentKey:0,
                original:'',
                translation:{},
                inputLang: null,
                translations:[],
                addLimit: false,
                rdateFormat: 'YYYY/MM/DD',
                formItemLayout,
                formTailLayout,
                skipass: {prices:{}},
                locale,
                types: [
                    {"value": '0', "label": 'Dospelý'},
                    {"value": '1', "label": 'Junior / senior'},
                    {"value": '2', "label": 'Dieťa'},
                ],
                addTerm: false,
                sortedInfo: null,
                aiTranslating: false,
                bulkTranslating: false,
                rowTranslating: null,
                targetLang: undefined,
                saving: false,
            };
        },
        computed: {
            // translations môže byť pole alebo objekt (mapa) - normalizujeme na pole záznamov
            translationList() {
                const t = this.translations;
                if (Array.isArray(t)) return t;
                if (t && typeof t === 'object') return Object.values(t);
                return [];
            },
            untranslatedCount() {
                return this.translationList.filter(t => t && t.text && t.translang && !t.translation).length;
            },
            targetLangLabel() {
                const l = (this.langs || []).find(x => x.value === this.targetLang);
                return l ? l.label : this.targetLang;
            },
            dirtyCount() {
                return this.translationList.filter(t => t && t._dirty).length;
            },
            // Koľko termínov treba preložiť do zvoleného cieľového jazyka (bez už preložených)
            missingForTargetCount() {
                if (!this.targetLang) return 0;
                return this.translationList.filter(t =>
                    t && t.text && t.lang !== this.targetLang &&
                    !(t.translang === this.targetLang && t.translation)
                ).length;
            },
            columns() {
                let { sortedInfo, filteredInfo } = this;
                sortedInfo = sortedInfo || {};
                filteredInfo = filteredInfo || {};
                const columns = [
                    {
                        title: 'Popis bloku',
                        dataIndex: 'des',
                        sorter: true,
                        width: '20%',
                    },
                    {
                        title: 'Jazyk',
                        scopedSlots: {customRender: 'language'},
                        filters: this.language,
                        onFilter: (value, record) => record.language.includes(value),
                        dataIndex: 'language',
                    },
                    {
                        title: 'Typ obsahu',
                        scopedSlots: {customRender: 'contenttype'},
                        filters: this.ctt,
                        onFilter: (value, record) => record.content_type.includes(value),
                        dataIndex: 'showon',
                    },

                    {
                        align: 'right',
                        scopedSlots: {customRender: 'name'},
                    }
                ];
                return columns;     },
        },
        mounted() {
            this.fetch();


            dataService.axiosFetch("contenttypes").then(results => {
                this.contenttypes = results;

                results.forEach(obj => {
                    var iid = obj.id;
                    var vval = obj.title;
                    this.ctt.push({"text" : vval,"value" : iid});


                });
            });

            dataService.axiosFetch('languages').then(results => {
                results.forEach(obj => {
                    if(obj.def === "1") this.translation.lang = obj.short; else this.translation.translang = obj.short;  this.langs.push({"value" : obj.short , "label" : obj.title});
                });
            });
        },
        methods: {
            openNew: function(e) {
                this.addTerm = true;

                this.translation = e;

            },
            openAdd() {
                // Nový termín - predvyplň jazyky z načítaných langs
                const def = this.langs && this.langs.length ? this.langs[0].value : '';
                const other = this.langs && this.langs.length > 1 ? this.langs[1].value : '';
                this.translation = { lang: def, translang: other, text: '', translation: '' };
                this.addTerm = true;
            },

            // Nízkoúrovňové AI volanie: preloží reťazec do cieľového jazyka. Vracia Promise<string|null>.
            callAiTranslate(string, targetLang) {
                return dataService.axiosPost('translateai', { lang: targetLang, string: string }).then(results => {
                    const d = results && results.data;
                    if (!d) return null;
                    // odpoveď býva pole [preklad] alebo priamo text
                    if (Array.isArray(d)) return d[0];
                    if (d.success === false) return null;
                    return d;
                });
            },

            // Dávkové AI volanie: preloží blok reťazcov v jednom requeste.
            // strings = [{id, text}], vracia Promise<{ translations:{id:text}, success?, message? }>
            callBatchTranslate(strings, targetLang) {
                return dataService.axiosPost('translatelocalbatch', { lang: targetLang, strings: strings }).then(results => {
                    const d = results && results.data ? (results.data.data !== undefined ? results.data.data : results.data) : null;
                    return d;
                });
            },

            // Spoločný dávkový preklad položiek do targetLang.
            // Posiela po blokoch (50), zapisuje preklady späť do item.translation a označí _dirty.
            // Vracia súhrn { ok, failed }.
            async batchTranslateItems(items, targetLang) {
                const CHUNK = 50;
                let ok = 0, failed = 0, done = 0;
                const total = items.length;
                this.$message.loading({ content: 'Prekladám 0/' + total + '...', key: 'bulkTrans', duration: 0 });

                for (let i = 0; i < items.length; i += CHUNK) {
                    const chunk = items.slice(i, i + CHUNK);
                    // id = index položky v tomto chunku, namapujeme späť cez mapu
                    const idMap = {};
                    const payload = chunk.map((item, idx) => {
                        const id = String(i + idx);
                        idMap[id] = item;
                        return { id: id, text: item.text };
                    });

                    try {
                        const res = await this.callBatchTranslate(payload, targetLang);
                        const translations = res && res.translations ? res.translations : null;

                        if (!translations) {
                            // celý chunk zlyhal
                            failed += chunk.length;
                        } else {
                            for (const id in idMap) {
                                const item = idMap[id];
                                const tr = translations[id];
                                if (tr != null && tr !== '') {
                                    this.$set(item, 'translang', targetLang);
                                    this.$set(item, 'translation', tr);
                                    this.$set(item, '_dirty', true);
                                    ok++;
                                } else {
                                    failed++;
                                }
                            }
                        }
                    } catch (e) {
                        failed += chunk.length;
                    }

                    done += chunk.length;
                    this.$message.loading({ content: 'Prekladám ' + Math.min(done, total) + '/' + total + '...', key: 'bulkTrans', duration: 0 });
                    // krátka pauza medzi blokmi
                    await new Promise(r => setTimeout(r, 200));
                }

                return { ok, failed };
            },

            // Preklad aktuálneho záznamu v modáli (vyplní pole translation)
            translateCurrent() {
                if (!this.translation.text || !this.translation.translang) return;
                this.aiTranslating = true;
                this.callAiTranslate(this.translation.text, this.translation.translang).then(res => {
                    this.aiTranslating = false;
                    if (res == null || res === '') {
                        this.$message.error('AI preklad sa nepodaril.');
                        return;
                    }
                    this.$set(this.translation, 'translation', res);
                    this.$message.success('Preklad bol vygenerovaný.');
                }).catch(() => {
                    this.aiTranslating = false;
                    this.$message.error('Chyba pri komunikácii s AI prekladom.');
                });
            },

            // Preklad jedného riadku v tabuľke (len lokálne, uloží sa cez Uložiť)
            translateRow(datas, key) {
                if (!datas.text || !datas.translang) return;
                this.rowTranslating = key;
                this.callAiTranslate(datas.text, datas.translang).then(res => {
                    this.rowTranslating = null;
                    if (res == null || res === '') {
                        this.$message.error('AI preklad sa nepodaril.');
                        return;
                    }
                    this.$set(datas, 'translation', res);
                    this.$set(datas, '_dirty', true);
                    this.$message.success('Preklad vygenerovaný - nezabudnite uložiť.');
                }).catch(() => {
                    this.rowTranslating = null;
                    this.$message.error('Chyba pri preklade.');
                });
            },

            // Kompletný preklad VŠETKÝCH termínov do zvoleného cieľového jazyka
            async translateAllToTarget() {
                if (!this.targetLang) {
                    this.$message.warning('Vyberte cieľový jazyk.');
                    return;
                }
                // Prekladáme len záznamy, ktoré:
                // - majú originálny text,
                // - originál nie je už v cieľovom jazyku,
                // - a ešte NEMAJÚ preklad do cieľového jazyka (existujúce preklady nechávame tak).
                const list = this.translationList.filter(t =>
                    t && t.text && t.lang !== this.targetLang &&
                    !(t.translang === this.targetLang && t.translation)
                );
                if (!list.length) {
                    this.$message.info('Všetky termíny už sú preložené do tohto jazyka.');
                    return;
                }
                this.bulkTranslating = true;
                const { ok, failed } = await this.batchTranslateItems(list, this.targetLang);
                this.$message.success({
                    content: 'Preložené do ' + this.targetLangLabel + ': ' + ok + (failed ? ', ' + failed + ' zlyhalo' : '') + '. Nezabudnite uložiť.',
                    key: 'bulkTrans',
                    duration: 5
                });
                this.bulkTranslating = false;
            },

            // Hromadný preklad všetkých chýbajúcich prekladov (dávkovo, zoskupené podľa cieľového jazyka)
            async translateAllMissing() {
                const missing = this.translationList.filter(t => t && t.text && t.translang && !t.translation);
                if (!missing.length) {
                    this.$message.info('Žiadne chýbajúce preklady.');
                    return;
                }
                this.bulkTranslating = true;

                // Zoskup podľa cieľového jazyka (translatelocalbatch berie jeden lang na volanie)
                const groups = {};
                missing.forEach(item => {
                    (groups[item.translang] = groups[item.translang] || []).push(item);
                });

                let ok = 0, failed = 0;
                for (const lang in groups) {
                    const res = await this.batchTranslateItems(groups[lang], lang);
                    ok += res.ok;
                    failed += res.failed;
                }

                this.$message.success({
                    content: 'Preložené: ' + ok + (failed ? ', ' + failed + ' zlyhalo' : '') + '. Nezabudnite uložiť.',
                    key: 'bulkTrans',
                    duration: 5
                });
                this.bulkTranslating = false;
            },

            // Uloží všetky neuložené (dirty) preklady na server
            saveAll() {
                const dirty = this.translationList.filter(t => t && t._dirty);
                if (!dirty.length) {
                    this.$message.info('Žiadne neuložené zmeny.');
                    return;
                }
                this.saving = true;
                const count = dirty.length;
                const hide = this.$message.loading('Ukladám ' + count + ' prekladov...', 0);

                // Pošleme všetky neuložené záznamy naraz cez dávkový endpoint
                const translations = dirty.map(item => ({
                    lang: item.lang,
                    translang: item.translang,
                    text: item.text,
                    translation: item.translation
                }));

                dataService.axiosPost('addlocaltranslationbatch', { translations: translations }).then(res => {
                    hide();
                    this.saving = false;
                    const d = res && res.data ? (res.data.data !== undefined ? res.data.data : res.data) : null;

                    if (!d || d.success === false) {
                        this.$message.error((d && d.message) || 'Uloženie zlyhalo.');
                        return;
                    }

                    const saved = d.saved != null ? d.saved : count;
                    let msg = 'Uložené: ' + saved + ' prekladov';
                    if (d.inserted != null || d.updated != null) {
                        msg += ' (nové ' + (d.inserted || 0) + ', aktualizované ' + (d.updated || 0) + ')';
                    }
                    if (d.skipped) msg += ', preskočené ' + d.skipped;
                    this.$message.success(msg + '.');

                    // Po uložení znovu načítame zoznam zo servera (zdroj pravdy)
                    this.fetch();
                }).catch(() => {
                    hide();
                    this.saving = false;
                    this.$message.error('Chyba pri ukladaní.');
                });
            },
            moment,
            formatDateN: function(dt){
                return moment(dt,'YYYY-MM-DD').format('D.M.YYYY')
            },
            confirm(e) {
                dataService.axiosDelete('skipass', e).then(results => {
                    if (results) {
                        delete this.data[e];
                        this.componentKey = this.componentKey + 1;
                    }
                });
            },
            handleLimit()
            {
                dataService.axiosPost('addskipasslimit', { 'skipass' : this.skipass}).then(results => {
                    this.fetch();
                    this.addLimit = false;
                });
            },
            handleOk(){

                dataService.axiosPost('addlocaltranslation', this.translation).then(results => {
              this.fetch();
                    this.addTerm = false;
                });
            },
            cancel() {
            },
            handleChange(pagination, filters, sorter) {
                this.filteredInfo = filters;
                this.sortedInfo = sorter;
            },
            clearFilters() {
                this.filteredInfo = null;
            },
            editing(w)
            {

                this.skipass.prices = this.data[w];
                this.skipass.daterange = [moment(w,this.rdateFormat),moment(w,this.rdateFormat)];

                this.addTerm = true;
            },
            fetchcttitle(ct)
            {
                let tcc = this.contenttypes.find(x => x.slug === ct);
                return tcc.title;
            },
            fetch() {
                this.loading = true;
                dataService.axiosFetch("localtranslations").then(results => {
                    // Backend môže vrátiť chybový objekt {success:false, message}
                    if (results && results.success === false) {
                        this.translations = [];
                        this.loading = false;
                        this.$message.error('Nepodarilo sa načítať preklady: ' + (results.message || 'chyba servera.'));
                        return;
                    }
                    // normalizácia na pole/objekt riešime cez computed translationList
                    this.translations = results || [];
                    this.loading = false;
                }).catch(() => {
                    this.translations = [];
                    this.loading = false;
                    this.$message.error('Nepodarilo sa načítať preklady (chyba servera).');
                });
            }

        },
    };
</script>

<style>
    .row-dirty td
    { background: #fffbe6; }
    .prices-row label
    {width:100px;}
    .prices-row
    {display:inline-block;}
    .priceInput
    {border:1px solid #bdd1e4;}
    .price-input
    {text-align:center;
    }
    .skipass-prices td{
        min-width:150px;
    }
    .skipass-prices tbody th{
        min-width:250px;
        font-weight:100;
    }
    .price-input strong
    {margin-bottom:5px;display:block;}
    .price-input
    {
        margin-left:10px; width:50px;display:inline-block;
    }
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }
    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination5-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a, .ant-pagination5-jump-prev a, .ant-pagination5-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: 0.875rem;
    }


    .ant-pagination5-item.ant-pagination5-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

</style>
